<template>
  <v-container>
    <v-row>
      <v-col md="6">
        <h1 class="font-weight-medium">{{ $t('Evento DO Cava') }}:
          <span v-if="$i18n.locale=='es'">{{ evento.nombre_es }} </span>
          <span v-else>{{ evento.nombre_ca }} </span>
          <span
              style="font-size:17px;color:#67833D"></span>
        </h1>
        <h2 class="has-text-danger text-uppercase" style="color:orange;padding-bottom: 30px" v-if="evento.state==-1">
          {{ $t("Cancelado") }}</h2>

        <v-btn :to="'/eventos/admin/edit/'+evento.uuid" large color="primary" dark>
          {{ $t('Editar evento') }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="6">
        <pic :evento="evento"/>
      </v-col>
      <v-col md="6">
        <direcciones :evento="evento"/>
        <event-text :evento="evento"/>
        <div class="pt-5">
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="6">
        <h2 class="font-weight-medium">Bodegas </h2>
        <br>
        <p><a target="_blank" :href="$store.state.baseurl+'/get-signups/'+evento.uuid">Bajar Bodegas</a></p>

        <p><a target="_blank"
              :href="$store.state.baseurl+'/get-participants/'+evento.uuid">{{ $t("Bajar Invitados") }}</a></p>
        <v-select @input="search"
                  v-model="liststate"
                  :items="list"
                  :item-text="'name'"
                  :item-value="'code'"
                  label="Filtrar Invitados / No invitados"
                  solo
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="12">
        <v-simple-table>
          <thead>
          <tr>
            <th>{{ $t("Bodegas Invitados") }}</th>
            <th>{{ $t("Confirmado") }}</th>
            <th>{{ $t("N. de cavas") }}</th>
            <th>{{ $t("N. de invitados") }}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in parts.results">
            <td>
              {{ item.bodega.nombre_comercial }}
            </td>
            <td>
              <v-btn :to="{name:'subscribe', params:{id: item.id}}" v-if="item.ok" large color="primary" dark>
                Sí
              </v-btn>
              <v-btn v-else large color="red" dark>
                No
              </v-btn>
            </td>
            <td>{{ item.cavas.length }}</td>
            <td>{{ item.participate_person.length }}</td>
          </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-row>
      <v-pagination
          v-model="page"
          :length="length"
          :page="page"
          total-visible="5"
      ></v-pagination>
    </v-row>
  </v-container>
</template>


<script>

import axios from "axios"
import EventText from "@/components/EventText";
import Pic from "@/components/Pic";
import Direcciones from "@/components/Direcciones";

export default {
  components: {Direcciones, Pic, EventText},
  data() {
    return {

      id: null,
      showform: false,
      evento: null,
      parts: [],
      length: 1,
      page: 1,
      list: [
        {name: "Todos", code: "x"},
        {name: "Confirmados", code: 1},
        {name: "No Confirmados", code: 0},
      ],
      liststate: "X"
    };
  },
  methods: {
    search() {
      let data = {}
      data.page = this.page
      data.evento__uuid = this.$route.params.id
      data.ok = this.liststate

      const config2 = {
        headers: {Authorization: "Bearer " + this.$store.state.jwt},
        params: data
      };


      console.log(this.liststate)

      axios.get(this.$store.state.endpoints.participacion, config2)
          .then((response) => {
            this.parts = response.data
            this.length = Math.ceil(response.data.count / 10)
          })
          .catch(error => {
            console.log(error)
          });
    }
  },
  watch: {
    page: function (newQuestion, oldQuestion) {
      this.search()
    }
  },
  created() {
    if (this.$route.params.id) {
      this.id = this.$route.params.id + "/"
      const config = {
        headers: {Authorization: "Bearer " + this.$store.state.jwt},
      };
      axios.get(this.$store.state.endpoints.evento + this.id, config)
          .then((response) => {
            this.evento = response.data
          })
          .catch(error => {
            console.log(error)
          });
      this.search()
    }
  }
}
</script>






